/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export class Resource {
  private readonly _embedded: { entityModels: unknown } | undefined = undefined;

  getEmbeddedResources() {
    return this._embedded?.entityModels;
  }
}

